import { c as _c } from "react/compiler-runtime";
import { Heading, LayoutContainer, Header as SparkyHeader } from '@petsmart-ui/sparky';
import { LogoWrapper } from '@libs/contentful';
import { Navigation } from '@/components/Navigation/Navigation';
import { useCurrentPageTitle } from '@/hooks';
import { UserMenu } from '../UserMenu/UserMenu';
import './header.scss';
export function Header() {
  const $ = _c(7);
  const pageTitle = useCurrentPageTitle();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="c-global-merchant-header__network-reminder">Access requires connection to the corporate VPN or network</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="header-item left-item"><Navigation /><LogoWrapper className="c-global-header__logo" data-testid="logo-wrapper" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== pageTitle) {
    t2 = <div className="header-item center-item"><Heading data-testid="sparky-heading" className="c-global-header-simple__heading" tagName="h1" size="title">{pageTitle}</Heading></div>;
    $[2] = pageTitle;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="header-item right-item"><UserMenu /></div>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <div className="c-global-merchant-header"><SparkyHeader data-testid="sparky-header">{t0}<LayoutContainer data-testid="layout-container"><SparkyHeader.Middle hideMenuButton={true} className="sparky-u-padding-left-none sparky-u-padding-right-none">{t1}{t2}{t3}</SparkyHeader.Middle></LayoutContainer></SparkyHeader></div>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}